import React from "react";
import { DataTable, InfoCard } from "best-common-react";

const cols = [
  {
    key: "mw_event_type",
    name: "Event Type",
    sortable: true
  },
  {
    key: "event_sub_type",
    name: "Event Sub Type",
    sortable: true
  },
  {
    key: "external_id",
    name: "Event Id",
    sortable: true
  }
];
const EventMappings = params => {
  if (params.mappings?.length === 0) {
    return <div>No mappings</div>;
  }

  return (
    <DataTable
      id="eventMappingTable"
      data={_.sortBy(params.mappings, ["mw_event_type", "event_sub_type"])}
      columns={cols}
      // sortFunc={this.onGridSort}
      height={400}
      selectAll={false}
    />
  );
};

export default EventMappings;
